module.exports = __webpack_public_path__ + "static/ig_banner_06-f51d14856a7843cb1577fe7422d18584.png";